import { toRawDeep } from './helpers'

const key = 'ownbit-configurator'

export function getKey(uuid?: string) {
  if (uuid) {
    return `${key}-${uuid}`
  }
  return key
}

/**
 * Get the stored data from the client side
 */
export function get(uuid?: string) {
  let clientSideData: OwnbitConfigurator.AggregateStorableState | undefined
  const key = getKey(uuid)

  const configuratorSessionDataFromSessionStorage = sessionStorage.getItem(key)

  // Migration: If there is data in session storage, move it to local storage
  if (configuratorSessionDataFromSessionStorage) {
    localStorage.setItem(key, configuratorSessionDataFromSessionStorage)
    sessionStorage.removeItem(key)
  }

  const configuratorSessionData = localStorage.getItem(key)
  if (configuratorSessionData) {
    clientSideData = JSON.parse(configuratorSessionData)
  }
  return clientSideData
}

/**
 * Set the stored data for the client side
 */
export function set(value: OwnbitConfigurator.AggregateStorableState, uuid?: string) {
  const key = getKey(uuid)
  localStorage.setItem(key, JSON.stringify(toRawDeep(value)))
}

/**
 * Clear the stored data from the client side
 */
export function clear(uuid?: string) {
  const key = getKey(uuid)
  localStorage.removeItem(key)
}
